module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "years"
    }
  }, [_c('h1', [_vm._v("40 Years")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("’Twas 40 years ago I said")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("To Ken, I think it’s time we wed")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("We’d lived together 3 years or so")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("And if I’d left it up to him, I know")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("We would still be in that same place")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("And I would not have had a happy face")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("So, take Friday off, as work’s a bit slow")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("And down to the registry office we will go")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("No one knew what we did that day")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("And when we rang the families, they were all away")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("We went to the Pizza Hut for our wedding feast")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("And we had pizza and a carafe of wine at least")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("So happy we were when we went back to our home")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("The families we tried again to phone")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Oh well! They would find out in due course")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("As we knew this one wouldn’t end in divorce")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Still happy and smiling we are to this day")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("And I’m sure to the end it will stay this way")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7996fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch014.vue
// module id = 102
// module chunks = 0